import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FilterState {
    title: string;
    newsSearch: string;
    materialsSearch: string;
    productType: number[];
    animalType: number[];
    animalAge: number[];
    animalNeeds: number[];
    feedingType: number[];
    animalTypesCategory: number[];
    animalPackaging: number[];
    newsFilterTags: number[];
    materialsFilterTags: number[];
    materialsSelected: number[];
    checkboxesCategory: number | null;
    checkboxesCategoryType: number | null;
    footerTab: number;
}

const initialState: FilterState = {
    title: '',
    newsSearch: '',
    materialsSearch: '',
    productType: [],
    animalType: [],
    animalAge: [],
    animalNeeds: [],
    feedingType: [],
    animalTypesCategory: [],
    animalPackaging: [],
    checkboxesCategory: null,
    checkboxesCategoryType: null,
    newsFilterTags: [],
    materialsFilterTags: [],
    materialsSelected: [],
    footerTab: 0
};

const animalsSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload
        },
        setNewsSearch: (state, action: PayloadAction<string>) => {
            state.newsSearch = action.payload
        },
        setMaterialsSearch: (state, action: PayloadAction<string>) => {
            state.materialsSearch = action.payload
        },
        setProductType: (state, action: PayloadAction<number[]>) => {
            state.productType = action.payload;
        },
        setAnimalType: (state, action: PayloadAction<number[]>) => {
            state.animalType = action.payload;
        },
        setAnimalAge: (state, action: PayloadAction<number[]>) => {
            state.animalAge = action.payload;
        },
        setAnimalNeeds: (state, action: PayloadAction<number[]>) => {
            state.animalNeeds = action.payload;
        },
        setFeedingType: (state, action: PayloadAction<number[]>) => {
            state.feedingType = action.payload;
        },
        setAnimalTypesCategory: (state, action: PayloadAction<number[]>) => {
            state.animalTypesCategory = action.payload
        },
        setAnimalPackaging: (state, action: PayloadAction<number[]>) => {
            state.animalPackaging = action.payload
        },
        setCheckboxesCategory: (state, action: PayloadAction<number>) => {
            state.checkboxesCategory = action.payload
        },
        setCheckboxesCategoryType: (state, action: PayloadAction<number>) => {
            state.checkboxesCategoryType = action.payload
        },
        setNewsFilterTags: (state, action: PayloadAction<number[]>) => {
            state.newsFilterTags = action.payload
        },
        setMaterialsFilterTags: (state, action: PayloadAction<number[]>) => {
            state.materialsFilterTags = action.payload
        },
        setMaterialsSelected: (state, action: PayloadAction<number[]>) => {
            state.materialsSelected = action.payload
        },
        setFooterTab: (state, action: PayloadAction<number>) => {
            state.footerTab = action.payload
        },
        setResetCatalogFilters: (state) => {
            state.title = '',
                state.animalAge = [],
                state.animalNeeds = [],
                state.animalType = [],
                state.animalTypesCategory = [],
                state.feedingType = [],
                state.productType = [],
                state.animalPackaging = [],
                state.checkboxesCategory = null,
                state.checkboxesCategoryType = null,
                state.footerTab = 0
        },
        setResetNewsFilters: (state) => {
            state.newsSearch = '',
                state.newsFilterTags = []
        },
        setResetMaterialsFilters: (state) => {
            state.materialsSearch = '',
                state.materialsFilterTags = [],
                state.materialsSelected = []
        }
    },
});

export const { setTitle, setProductType, setAnimalType, setAnimalTypesCategory, setAnimalAge, setAnimalNeeds, setFeedingType, setNewsSearch, setNewsFilterTags, setMaterialsSearch, setMaterialsFilterTags, setMaterialsSelected, setFooterTab, setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters, setAnimalPackaging, setCheckboxesCategory, setCheckboxesCategoryType } = animalsSlice.actions;
export default animalsSlice.reducer;

export type AnimalsSliceState = ReturnType<typeof animalsSlice.reducer>;
export type AnimalsActions = typeof animalsSlice.actions;